export function WaitlistButton({ loading = false }: { loading?: boolean }) {
  return (
    <button
      type="submit"
      disabled={loading}
      className="group relative rounded-full hover:scale-105 active:scale-95 transition-transform disabled:opacity-70 disabled:pointer-events-none"
      style={{ padding: "0.6px", border: "0.6px solid rgba(255,255,255,0.6)" }}
    >
      {/* Top glow streak */}
      <div
        className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[6px] w-[60%] rounded-full blur-[6px]"
        style={{ background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)" }}
      />
      {/* Inner pill */}
      <div
        className="relative rounded-full text-sm font-medium bg-white text-black"
        style={{ padding: "11px 29px", fontSize: "14px" }}
      >
        {loading ? "Joining..." : "Join Waitlist"}
      </div>
    </button>
  );
}
